import { Loader } from "@mantine/core";
import React from "react";

interface LoadScreenProps {
    header?: string;
    body?: string;
}

export const LoadScreen: React.FC<LoadScreenProps> = ({ header, body }) => {
    return (
        <div
            className="d-flex flex-column justify-content-center text-center align-items-center"
            style={{ height: "80vh" }}
        >
            {header && <h1>{header}</h1>}
            {body && <p>{body}</p>}
            <Loader style={{ alignItems: "center" }} color="primary" />
        </div>
    );
};

export default LoadScreen;
